module.exports = __webpack_public_path__ + "img/comprehensiveImg3.35678140.png";